import React from 'react';
import { useHistory } from 'react-router-dom';

const ACTIONS = [
  { label: 'New Product',  icon: 'fas fa-tag',            href: '/adminpanel/products/newProduct', color: '#ec174f' },
  { label: 'New Recipe',   icon: 'fas fa-concierge-bell', href: '/adminpanel/recipes/new-recipe',  color: '#7c3aed' },
  { label: 'New Coupon',   icon: 'fas fa-percent',        href: '/adminpanel/coupons',             color: '#2563eb' },
  { label: 'View Orders',  icon: 'fas fa-shopping-bag',   href: '/adminpanel/orders',              color: '#059669' },
];

const QuickActions = () => {
  const history = useHistory();

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Quick Actions</p>
      </div>
      <div className="admin-card-body">
        <div className="quick-actions-grid">
          {ACTIONS.map(({ label, icon, href, color }) => (
            <button
              key={href}
              className="quick-action-btn"
              onClick={() => history.push(href)}
            >
              <span className="quick-action-icon" style={{ background: `${color}18`, color }}>
                <i className={icon} />
              </span>
              <span className="quick-action-label">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
